/**
 * Read a design token out of the stylesheet.
 *
 * Recharts is configured in JavaScript, so its colours were living as literal
 * hexes in the component — eight of them in the reporting dashboard alone.
 * That meant the chart palette and the interface palette could drift apart,
 * and a rebrand meant hunting through JSX.
 *
 * index.css exposes the chart colours as custom properties. This reads them
 * back, so there is one source of truth.
 *
 *     <Area stroke={token('--ok')} fill={token('--ok-bg')} />
 */

const cache = new Map();

export function token(name, fallback = '') {
  if (typeof window === 'undefined' || !document.documentElement) return fallback;
  if (cache.has(name)) return cache.get(name);
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  const resolved = value || fallback;
  // Only cache a real hit. An early call — before the stylesheet has applied —
  // would otherwise poison the cache with the fallback for the whole session.
  if (value) cache.set(name, resolved);
  return resolved;
}

/** Drop the cache after a theme change, if one is ever added. */
export function clearTokenCache() {
  cache.clear();
}
